const chartWrapper = "flex flex-col sm:flex-row gap-4";

const chartContainer = "w-full sm:w-[280px] sm:shrink-0 h-[280px]";

export { chartWrapper, chartContainer };
